import type { OrgIntent } from "@/types/api";

/**
 * A one-line summary of a stated intent, for list rows. "" when nothing is set,
 * so a caller can distinguish "not stated" and say so in its own words rather
 * than rendering an empty string that looks like a layout bug.
 */
export function intentSummary(intent: OrgIntent): string {
	const parts: string[] = [];
	if (intent.goal) parts.push(intent.goal);
	if (intent.domains?.length) parts.push(intent.domains.join(", "));
	return parts.join(" · ");
}
